import { Text } from "prism-react";

import { DevtoolMessage } from "./DevtoolMessage";

type Props = {
  processType: "TASK" | "UNASSIGNED_PORT";
  canRestartProcess: boolean;
  exitCode?: number;
  onAction: () => void;
};

export const PROCESS_LABEL: Record<Props["processType"], string> = {
  TASK: "Task",
  UNASSIGNED_PORT: "Dev server",
};

export const ProcessErroredMessage: React.FC<Props> = ({
  exitCode,
  canRestartProcess,
  onAction,
  processType,
}) => (
  <DevtoolMessage
    actions={[
      {
        actionText: canRestartProcess ? "Restart" : "Close",
        onAction: onAction,
      },
    ]}
    variant="error"
  >
    <Text>
      {PROCESS_LABEL[processType]} exited{" "}
      {exitCode ? (
        <>
          with code <strong>{exitCode}</strong>.
        </>
      ) : (
        <>.</>
      )}{" "}
      {canRestartProcess
        ? "Do you want to restart it?"
        : "Do you want to close it?"}
    </Text>
  </DevtoolMessage>
);
